var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookingsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 29,
    viewBox: "0 0 22 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66665 0.667969H20.3333C20.6869 0.667969 21.0261 0.808444 21.2761 1.05849C21.5262 1.30854 21.6666 1.64768 21.6666 2.0013V27.5253C21.6668 27.6445 21.635 27.7616 21.5745 27.8643C21.514 27.967 21.4271 28.0517 21.3228 28.1094C21.2185 28.1671 21.1007 28.1959 20.9815 28.1926C20.8624 28.1892 20.7463 28.1541 20.6453 28.0906L11 22.0413L1.35465 28.0893C1.2538 28.1527 1.13783 28.1878 1.01878 28.1912C0.899735 28.1946 0.781961 28.166 0.677706 28.1084C0.573452 28.0508 0.486522 27.9664 0.425957 27.8638C0.365391 27.7613 0.333402 27.6444 0.333313 27.5253V2.0013C0.333313 1.64768 0.473789 1.30854 0.723838 1.05849C0.973886 0.808444 1.31302 0.667969 1.66665 0.667969ZM19 3.33464H2.99998V23.9106L11 18.896L19 23.9106V3.33464Z",
    fill: "#98A2B3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingsIcon);
export default __webpack_public_path__ + "static/media/bookingsIcon.60048e52e47a5e2b661da25058bd5c8d.svg";
export { ForwardRef as ReactComponent };